import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { SecureRoute, LoginCallback } from "@okta/okta-react";
import AppWrapper from "./components/common/AppWrapper";
import config from "./app.config";
import FeatureFlagRoute from "./components/common/FeatureFlagRoute";

import Home from "./components/Home";
import Login from "./components/Login";
// import SampleList from "./components/Samples/List";
// import PatientList from "./components/Patients/List";
// import PatientAdd from "./components/Patients/Add";
// import PatientEdit from "./components/Patients/Edit";
// import SampleDetail from "./components/Samples/Detail";
// import TagList from "./components/Tags/List";
// import VendorList from "./components/Vendors/List";
// import VendorDetail from "./components/Vendors/Detail";
import QlpListUnProcessed from "./components/Qlp/List/Unprocessed";
import QlpAdd from "./components/Qlp/Add";
import QlpSearch from "./components/Qlp/Search";
import ddPcrListUnprocessed from "./components/ddPcr/List/Unprocessed";
import ddPcrListProcessed from "./components/ddPcr/List/Processed";
import ddPcrAdd from "./components/ddPcr/Add";
import ddPcrMFG from "./components/ddPcr/MFG";
//import DdpcrDetails from "./components/ddPcr/Detail";
import Profile from "./components/Profile";
import ViewRpt from "./components/ddPcr/MFG/ViewRpt";
import MfgRptDetails from "./components/ddPcr/MFG/MfgRptDetails";
import QlpQCUpload from "./components/common/FileUpload/QlpQCUpload";
import "../src/css/reset.css";
//import "./App.css";
//import '@radix-ui/themes/styles.css';
import QCPlatesList from "./components/QC/QCPlatesList";
import MfgAddSerialNum from "./components/ddPcr/MFG/MfgAddSerialNum";
import QCMetricsReport from "./components/QC/QCMetricsReport";
import CreateBatch from "./components/QC/CreateBatch";
import Details from "./components/ddPcr/Detail/Details";
import QlpFilesList from "./components/Qlp/QlpFiles/QlpFilesList";
import ErrorBoundary from "./Error/ErrorBoundary";
import QlpMetricsDisplayDocs from "./components/Qlp/MetricsDocumentation/QlpMetricsDisplayDocs";
import Qlp96WellMetricsDisplay from "./components/Qlp/96WellMetrics/Qlp96WellMetricDisplay";
import AutoDGPlateList from "./components/ddPcr/AutoDG/AutoDGPlateList";
import AutoDGReport from "./components/ddPcr/AutoDG/AutoDGReport";
import CreateAutoDGPlate from "./components/ddPcr/AutoDG/CreateAutoDGPlate";
import HelpPdf from "./components/Documents/HelpPdf";
import ChangeLogPdf from "./components/Documents/ChangeLogPdf";
import Register from "./components/Login/Register";

//TODO: commbine routes for QCmetricsReport

export default class App extends Component {
  render() {
    return (
      <div id="dbgApp">
        <AppWrapper>
          <div className="grid-x grid-padding-x">
            <div className="cell large-12 large-cell-block">

              <Switch>
                <Route path="/" exact={true} component={Home} />
                <Route path="/login/callback" component={LoginCallback} />
                <Route path="/login">
                  <Login issuer={config.url} />
                </Route>
                <Route path="/register">
                  <Register issuer={config.url} />
                </Route>

                <SecureRoute path="/profile"
                  component={Profile}
                />

                <SecureRoute exact={true} path="/help" component={HelpPdf} />

                <SecureRoute exact={true} path="/changeLog" component={ChangeLogPdf} />

                <SecureRoute path="/qlp/list/unprocessed" exact={true} component={QlpListUnProcessed} />

                <SecureRoute path="/qlp/add" exact={true}
                  component={QlpAdd} />

                <SecureRoute path="/display/documentation/qlp_metrics/" exact={true}
                  component={QlpMetricsDisplayDocs} />

                <SecureRoute path="/qlp/search" exact={true}
                  component={QlpSearch} />

                <FeatureFlagRoute path="/qlp/list_files" exact={true}
                  flagKey="mfg-qc-access" component={QlpFilesList} />

                <SecureRoute path="/qlp/qlp_metrics/:plate_uuid/:filename" exact={true}
                  component={Qlp96WellMetricsDisplay} />

                <FeatureFlagRoute path="/ddpcr/autoDG/dg_metrics/:plate_uuid" exact={true}
                  flagKey="mfg-qc-access" component={AutoDGReport} />

                <SecureRoute path="/ddpcr/list/unprocessed" exact={true} component={ddPcrListUnprocessed} />

                <SecureRoute path="/ddpcr/list/processed" exact={true} component={ddPcrListProcessed} />

                <SecureRoute path="/ddpcr/add" exact={true}
                  component={ddPcrAdd} />

                <FeatureFlagRoute path="/ddpcr/mfg" exact={true}
                  flagKey="mfg-qc-access" component={ddPcrMFG} />

                <FeatureFlagRoute path="/ddpcr/mfg/view-report" exact={true}
                  flagKey="mfg-qc-access" component={ViewRpt} />

                <FeatureFlagRoute path="/display/mfg_report/:rptuid/:serialnum" exact={true}
                  flagKey="mfg-qc-access" component={MfgRptDetails} />


                {/* React Router expects to directly receive Route or Redirect components as its children. When you wrap a Route or SecureRoute with
                ErrorBoundary, we are actually introducing a level of indirection which React Router can't handle correctly
                Instead of wrapping each route in an ErrorBoundary, have modified the component structure so that the
                ErrorBoundary wraps around the component we pass to the route's component prop.*/}

                {/* <SecureRoute path="/ddpcr/detail/:plateUuid" exact={true}
                  component={() => (
                    <ErrorBoundary>
                      <DdpcrDetails />
                    </ErrorBoundary>
                  )} /> */}

                <SecureRoute path="/ddpcr/detail/:plateUuid/:filename?" exact={true}
                  component={Details} />


                <FeatureFlagRoute path="/qlpqc/add" exact={true}
                  flagKey="mfg-qc-access" component={QlpQCUpload} />

                <FeatureFlagRoute path="/list_plates/:item" exact={true}
                  flagKey="mfg-qc-access" component={QCPlatesList} />

                <FeatureFlagRoute path="/qc/create_batch" exact={true}
                  flagKey="mfg-qc-access" component={CreateBatch} />

                <FeatureFlagRoute path="/qc/metrics/:plate_uuid/:platename" exact={true}
                  flagKey="mfg-qc-access" component={QCMetricsReport} />
                <FeatureFlagRoute path="/mfg/metrics/:plate_uuid/:platename" exact={true}
                  flagKey="mfg-qc-access" component={QCMetricsReport} />
                <FeatureFlagRoute path="/ddpcr/mfg/addSerialNum" exact={true}
                  flagKey="mfg-qc-access" component={MfgAddSerialNum} />
                <FeatureFlagRoute path="/ddpcr/autoDG/list_plates" exact={true}
                  flagKey="mfg-qc-access" component={AutoDGPlateList} />
                <FeatureFlagRoute path="/ddpcr/autoDG/add_plate" exact={true}
                  flagKey="mfg-qc-access" component={CreateAutoDGPlate} />



                {/* <SecureRoute
                  exact={true}
                  path="/sample/:samplePurpose/list"
                  component={SampleList}
                />

                <SecureRoute
                  exact={true}
                  path="/patient/list"
                  component={PatientList}
                />
                <SecureRoute
                  exact={true}
                  path="/patient/add"
                  component={PatientAdd}
                />
                <SecureRoute
                  exact={true}
                  path="/patient/edit/:patientId"
                  component={PatientEdit}
                />
                <SecureRoute
                  exact={true}
                  path="/sample/:samplePurpose/edit/:sampleId"
                  component={SampleDetail}
                />
                <SecureRoute
                  exact={true}
                  path="/sample/:samplePurpose/add"
                  component={SampleDetail}
                />
                <SecureRoute
                  exact={true}
                  path="/tag/list"
                  component={TagList}
                />
                <SecureRoute
                  exact={true}
                  path="/vendor/list"
                  component={VendorList}
                />
                <SecureRoute
                  exact={true}
                  path="/vendor/edit/:vendorId"
                  component={VendorDetail}
                />
                <SecureRoute
                  exact={true}
                  path="/vendor/add"
                  component={VendorDetail}
                /> */}
              </Switch>
            </div>
          </div>
        </AppWrapper>
      </div>
    );
  }
}
